var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalsa = function SvgHalsa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 70,
    height: 66,
    x: 0,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.82 6.175C4.25 13.997-4.222 33.32 2.896 49.31c7.127 16.007 27.157 22.642 44.726 14.82C65.209 56.3 73.68 36.976 66.56 20.987 59.435 4.98 39.406-1.656 21.82 6.175"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d96973",
    fillRule: "evenodd",
    d: "M79.459 49.955 15.803 78.297-10 20.34 53.656-8z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 36,
    height: 32,
    x: 16,
    y: 20,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.997 20.708h34.415v30.74H16.997z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m34.128 50.479.078.053.078-.054 3.163-2.316c3.097-2.415 7.39-6.191 10.22-10.435.874-1.313 1.562-2.602 2.045-3.834l.015-.042q.095-.24.177-.48l.054-.155.12-.378.053-.17a12 12 0 0 0 .122-.451l.057-.243.008-.036.043-.196.036-.166.037-.217q.12-.692.143-1.394l.002-.04.005-.19-.002-.139q0-.165-.008-.33l-.003-.063a8.7 8.7 0 0 0-1.546-4.572c-1.45-2.103-3.563-3.061-4.912-3.061-3.36 0-6.626 3.322-7.874 4.75a26 26 0 0 0-1.27 1.513l-.437.566a.43.43 0 0 1-.655 0l-.437-.566a26 26 0 0 0-1.272-1.515c-1.564-1.79-4.65-4.782-7.797-4.782-1.937.003-3.614 1.042-4.984 3.09-.948 1.418-1.47 2.967-1.55 4.603l-.003.042a9 9 0 0 0-.007.325l-.001.145c0 .047.002.102.004.156l.002.067q.023.7.142 1.39l.04.232.09.406a14 14 0 0 0 .176.682l.05.163.123.382.053.153a14 14 0 0 0 .175.477l.017.046c.483 1.23 1.17 2.52 2.045 3.831 2.83 4.245 7.123 8.02 10.226 10.44.017.013 2.39 1.786 3.159 2.312zm.078.968a.4.4 0 0 1-.234-.072l-.312-.213c-.783-.536-3.096-2.264-3.194-2.337-3.158-2.463-7.522-6.303-10.413-10.639-.907-1.36-1.623-2.704-2.127-3.992l-.018-.047a17 17 0 0 1-.185-.502l-.055-.159a13 13 0 0 1-.13-.406l-.052-.169a14 14 0 0 1-.191-.738c0-.001-.092-.412-.097-.44l-.04-.24a11 11 0 0 1-.154-1.502l-.002-.051-.005-.199.001-.15.008-.36.003-.044c.087-1.786.656-3.476 1.689-5.021 1.511-2.26 3.473-3.455 5.673-3.458 3.302 0 6.4 2.75 8.417 5.059q.684.754 1.308 1.56l.109.14.11-.14a26 26 0 0 1 1.306-1.558c1.316-1.508 4.792-5.027 8.492-5.027 1.559 0 3.974 1.07 5.595 3.42a9.5 9.5 0 0 1 1.691 5l.003.066q.008.183.009.362l.001.145q-.001.113-.005.219l-.001.038a11 11 0 0 1-.155 1.505l-.04.236-.04.183-.045.204-.008.036-.061.263-.132.487-.054.175a11 11 0 0 1-.129.403l-.055.159a14 14 0 0 1-.186.506l-.017.043c-.504 1.29-1.22 2.633-2.128 3.994-2.891 4.336-7.254 8.176-10.407 10.635l-3.198 2.342-.312.213a.4.4 0 0 1-.233.072"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.533 35.141a.21.21 0 0 0-.21.21v2.68c0 .122.094.216.21.216h2.706c.454 0 .824.37.824.822v2.722a.21.21 0 0 0 .16.204h2.727a.21.21 0 0 0 .21-.21v-2.702c0-.453.37-.822.823-.822h2.726a.21.21 0 0 0 .195-.13.2.2 0 0 0 .016-.08v-2.686a.21.21 0 0 0-.21-.21h-2.706a.824.824 0 0 1-.824-.822v-2.72c0-.1-.07-.183-.161-.206h-2.726a.21.21 0 0 0-.21.21v2.703c0 .453-.37.821-.824.821zm3.74 7.675a1.027 1.027 0 0 1-1.026-1.025v-2.722l-2.714-.007a1.027 1.027 0 0 1-1.026-1.025v-2.685c0-.565.46-1.025 1.026-1.025h2.726l.007-2.71c0-.564.46-1.024 1.026-1.024l2.677-.006a1.03 1.03 0 0 1 1.027 1.025v2.721l2.713.008c.566 0 1.026.46 1.026 1.024v2.686c0 .565-.46 1.024-1.026 1.024h-2.726l-.007 2.71c0 .565-.46 1.024-1.026 1.024z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgHalsa;